import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { DirectoryColumn } from 'src/app/samwebDescription/samweb/directory/directory-column';
import { DirectoryOrganisationDataSelectors } from 'src/app/store/samwin/directory/directory-organisation-data/directory-organisation-data.selectors';
import { OrganisationEntryRemoteDto } from 'src/generated/swagger';

@Pipe({
   name: 'directoryColumnStructureValue',
})
export class DirectoryColumnStructureValuePipe implements PipeTransform {
   constructor(private store: Store) {}
   transform(directoryColumn: DirectoryColumn, value: number): Observable<OrganisationEntryRemoteDto> {
      if (!directoryColumn.columnTyp.enumName.toUpperCase().includes('FLD_ORG')) {
         return of(null);
      }
      const key = directoryColumn.columnTyp.enumName.slice(-2);
      const result = this.store.select(DirectoryOrganisationDataSelectors.getDirectoryStructureValue).pipe(map((getEntry) => getEntry(key, value)));
      return result;
   }
}
